/**
 * Admin trusts — /admin/trusts (redirect stub).
 *
 * D2-01 consolidated this into /admin/clients; that legacy list is itself now
 * retired in favour of the Client Book (firms hold clients as first-class
 * tenants, operated via act-as). Redirect so existing bookmarks / links don't
 * hit a dead stub.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/trusts')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/client-book' });
  },
});
